"use client";

import type { JSONContent } from "@tiptap/core";
import type { Mark, Node } from "@tiptap/pm/model";
import { renderToReactElement } from "@tiptap/static-renderer";
import type { TiptapStaticRendererOptions } from "@tiptap/static-renderer/json/react";
import cn from "clsx";
import { useMemo } from "react";
import { getExtensionList, nodeMapping, type RTEditorType } from "./Extensions";
import styles from "./RTERenderer.module.css";

type RTERendererProps = Readonly<{
  content: JSONContent;
  type: RTEditorType;
  unstyled?: boolean;
  className?: string;
}>;

export function RTERenderer({ content, type, className, unstyled }: RTERendererProps) {
  const extensions = useMemo(() => getExtensionList(type), [type]);

  const renderedContent = useMemo(
    () =>
      renderToReactElement({
        extensions,
        content,
        options: {
          nodeMapping: nodeMapping as Partial<TiptapStaticRendererOptions<React.ReactNode, Mark, Node>>["nodeMapping"],
        },
      }),
    [content, extensions],
  );

  return (
    <div
      className={cn(
        "rte-renderer",
        { "rte-form-renderer": type === "form", "rte-document-renderer": type === "document" },
        className,
        { [styles.rteRenderStyles]: !unstyled },
      )}
    >
      {renderedContent}
    </div>
  );
}
